export var StreamStatsType;
(function (StreamStatsType) {
    StreamStatsType["Publisher"] = "publisher";
    StreamStatsType["Subscriber"] = "subscriber";
})(StreamStatsType || (StreamStatsType = {}));
